// @flow
import type { Location } from 'react-router-dom'

export const trackOutboundLink = (url: string) => {
  if (window.ga) {
    window.ga('send', 'event', 'ExternalLink', 'click', url, {
      transport: 'beacon',
      hitCallback: () => {
        document.location.href = url
      },
    })
  }
}

export const trackFilterEvent = (filter: string) => {
  if (window.ga) {
    window.ga('send', 'event', 'Gallery', 'filter', filter)
  }
}

export const trackSlideshowOpen = (location: Location) => {
  if (window.ga) {
    window.ga('send', 'event', 'Slideshow', 'open', location.pathname)
  }
}

export const trackSlideshowView = (location: Location, title: string) => {
  if (window.ga) {
    window.ga(
      'send',
      'event',
      'Slideshow',
      'view',
      `${location.pathname} - Image: ${title}`,
    )
  }
}



// WEBPACK FOOTER //
// ./src/analytics.js